export var CdnData;
(function (CdnData) {
    CdnData["Campaigns"] = "campaigns";
    CdnData["Updates"] = "updates";
})(CdnData || (CdnData = {}));
